import { configureStore } from "@reduxjs/toolkit";
import { backendApi } from "./api/backendApi";
import { shopifyCartApi } from "./api/shopifyCartApi";
import { shopifyStorefrontApi } from "./api/shopifyStorefrontApi";

export const store = configureStore({
  reducer: {
    [shopifyCartApi.reducerPath]: shopifyCartApi.reducer,
    [backendApi.reducerPath]: backendApi.reducer,
    [shopifyStorefrontApi.reducerPath]: shopifyStorefrontApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      shopifyCartApi.middleware,
      backendApi.middleware,
      shopifyStorefrontApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
